<div class="flex flex-col gap-6">
	<div class="flex flex-row items-center justify-between">
		<h2>Sesiones activas</h2>
		<activar-button
			text="Revocar otras sesiones"
			fill="out"
			color="danger"
			[disabled]="!canRevokeOthers()"
			(click)="askRevokeAll()" />
	</div>

	@if (loading()) {
		<p>Cargando sesiones...</p>
	} @else if (sessionsError()) {
		<div class="flex flex-col gap-3 items-start">
			<p>No pudimos cargar tus sesiones activas.</p>
			<activar-button text="Reintentar" fill="out" color="primary" (click)="retry.emit()" />
		</div>
	} @else if (sessions().length === 0) {
		<p>No hay sesiones activas.</p>
	} @else {
		<div class="flex flex-col gap-4">
			@for (session of sessions(); track session.id) {
				<div class="flex flex-row items-center justify-between border border-gray-200 rounded-md p-4">
					<div class="flex flex-col gap-1">
						<div class="flex items-center gap-2">
							<span class="font-semibold">{{ session.deviceLabel || session.userAgent || 'Dispositivo desconocido' }}</span>
							@if (session.current) {
								<span class="text-xs text-primary-900 bg-primary-100 rounded-full px-2 py-0.5">Sesión actual</span>
							}
						</div>
						<span class="text-sm text-gray-500">{{ session.ip }}</span>
						<span class="text-sm text-gray-500">
							Último uso: {{ session.lastUsedAt ? (session.lastUsedAt | date: 'dd/MM/yyyy HH:mm') : '—' }}
						</span>
					</div>

					<activar-button
						text="Revocar"
						fill="out"
						color="danger"
						[disabled]="session.current"
						(click)="askRevokeOne(session.id)" />
				</div>
			}
		</div>
	}
</div>

<activar-modal [(visible)]="showRevokeOneModal">
	<div class="flex-col mx-auto p-5 text-center" style="width: 400px">
		<h2>¿Revocar sesión?</h2>
		<p>El dispositivo perderá el acceso a la cuenta inmediatamente.</p>

		<div class="flex mt-7 items-center justify-center gap-5">
			<activar-button text="Cancelar" fill="out" expand="full" color="primary" (click)="closeRevokeOneModal()" />
			<activar-button text="Revocar" fill="solid" expand="full" color="danger" (click)="confirmRevokeOne()" />
		</div>
	</div>
</activar-modal>

<activar-modal [(visible)]="showRevokeAllModal">
	<div class="flex-col mx-auto p-5 text-center" style="width: 400px">
		<h2>¿Revocar otras sesiones?</h2>
		<p>Se cerrará la sesión en todos los demás dispositivos, manteniendo activa únicamente la sesión actual.</p>

		<div class="flex mt-7 items-center justify-center gap-5">
			<activar-button text="Cancelar" fill="out" expand="full" color="primary" (click)="closeRevokeAllModal()" />
			<activar-button text="Revocar otras" fill="solid" expand="full" color="danger" (click)="confirmRevokeAll()" />
		</div>
	</div>
</activar-modal>
